export default {
  methods: {
    hotelRoomOccupancy (bedTypeCombinationItems) {
      return bedTypeCombinationItems.reduce((occ, item) => occ + item.count * this._.get(item, 'bed_type.occupancy', 0), 0)
    }
  }
}
